// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1KJOI","label":"Completed_label__3OkW5"};